import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent, onMounted, ref } from 'vue';
import { addFinanceBudget, getDeptList } from '@/service/Finance/Budget';
import { Toast } from 'vant';
export default defineComponent({
  setup: function setup() {
    var form = ref({
      budgetAmt: '',
      orgId: '',
      orgName: '',
      remark: '',
      extFiled4: ''
    });
    var btnDisabled = ref(false);
    var deptList = ref([]);
    var showPicker = ref(false);
    var onConfirm = function onConfirm(data) {
      if (data) {
        form.value.orgId = data.orgId;
        form.value.orgName = data.orgName;
        form.value.extFiled4 = data.orgNameShort;
      }
      showPicker.value = false;
    };
    var handleSubmit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (form.value.orgId) {
                _context.next = 3;
                break;
              }
              Toast('请选择组织！');
              return _context.abrupt("return", false);
            case 3:
              if (form.value.budgetAmt) {
                _context.next = 6;
                break;
              }
              Toast('请输入金额！');
              return _context.abrupt("return", false);
            case 6:
              _context.prev = 6;
              btnDisabled.value = true;
              _context.next = 10;
              return addFinanceBudget(form.value);
            case 10:
              res = _context.sent;
              Toast(res.info);
              if (res.status == '1') {
                form.value = {
                  budgetAmt: '',
                  remark: '',
                  orgId: '',
                  orgName: '',
                  extFiled4: ''
                };
              }
              btnDisabled.value = false;
              _context.next = 20;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](6);
              console.log(_context.t0);
              btnDisabled.value = false;
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[6, 16]]);
      }));
      return function handleSubmit() {
        return _ref.apply(this, arguments);
      };
    }();
    var _getDeptList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return getDeptList();
            case 3:
              res = _context2.sent;
              deptList.value = res.data.list;
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 7]]);
      }));
      return function _getDeptList() {
        return _ref2.apply(this, arguments);
      };
    }();
    onMounted(function () {
      _getDeptList();
    });
    return {
      form: form,
      btnDisabled: btnDisabled,
      showPicker: showPicker,
      deptList: deptList,
      onConfirm: onConfirm,
      handleSubmit: handleSubmit
    };
  }
});